import { methods, ServiceMaker } from './index';

const { GET } = methods;

export const getuser = (mnumber) =>ServiceMaker(`/v1/api/customer/userdetails/${mnumber}`, GET, null)